import React from "react";

const Scanner = () => {

    const handleTakealotLink = () => {
        window.open("https://www.takealot.com/a3-visualizer-scanner/PLID73017910", "_blank");
    }

    const handleDownloadBrochure = () => {

        window.open(
          "https://teacher-tech.s3.us-east-2.amazonaws.com/pdfs/TopMarks_Scanner_Brochure+(5).pdf",
          "_blank",
          "noopener,noreferrer"
        );
    }


  return (
    <div className="help-main">
      <div className="help-overview-head">
        <div className="help-overview-head-left">V8 Scanner</div>
        <div className="help-overview-head-right">
          <button className="help-download-btn" onClick={handleDownloadBrochure}>Download Brochure</button>
        </div>
      </div>
      <div className="help-content">
        <h1 className="help-main-title">Do you need a scanner ?</h1>
        <h3 className="help-main-subtitle">
          The most powerfull and affordable USB-based document camera has
          arrived.
        </h3>
        {/* 1. Installation */}
        <div className="help-section">
          <h2 className="help-section-title">1. Installation</h2>
          <img
            src="/help/TT_scan_1.png"
            alt="Scanner"
            className="help-section-image"
          />
          <div
           onClick = {handleTakealotLink}
            className="help-step-item"
          >
            Item Link:{" "}
            <span className="help-section-description-link">
              https://www.takealot.com/a3-visualizer-scanner/PLID73017910
            </span>
          </div>
          <div className="help-step-item">
            Please click on the link above to purchase the Viisan V8 Document
            Scanner from Takealot.
          </div>
        </div>

        {/* Usage Instructions */}
        <div className="help-section">
          <h2 className="help-section-title">2. Usage Instructions</h2>
          <h3 className="help-step-item"> Step 1</h3>
          <div className="help-section-description">
            Once you have downloaded and installed the Viisan V8 software, plug
            your scanner into your computer using the cable provided and then
            open the software. Click on the DOCUMENT tab at the top of the
            screen and this will put the software into Scanning Mode.
          </div>
          <img
            src="/help/TT_scan_2_1.png"
            alt="Scanner"
            className="help-section-image"
          />

          <hr className="help-section-divider" />

          {/* step 2 */}
          <h3 className="help-step-item"> Step 2</h3>
          <div className="help-section-description">
            In order to scan multiple pages easily, ensure you select the
            settings as they appear in the image below.
          </div>
          <img
            src="/help/TT_scan_2_2.png"
            alt="Scanner"
            className="help-section-image"
          />

          <hr className="help-section-divider" />

          {/* step 3 */}
          <h3 className="help-step-item"> Step 3</h3>
          <div className="help-section-description">
            Place the papers in the correct sequence in a pile under the Scanner
            and then click on the START button. The software will give you a
            countdown and then scan the 1st page (you will see the scanned page
            appear on the Left Hand Side of the software). Remove the scanned
            page and then the software will give you another countdown and scan
            the next page. Repeat this process until all of the pages are
            scanned.
          </div>
          <img
            src="/help/TT_scan_2_3.png"
            alt="Scanner"
            className="help-section-image"
          />

          <hr className="help-section-divider" />

          {/* step 4 */}
          <h3 className="help-step-item"> Step 4</h3>
          <div className="help-section-description">
            Once you have scanned all of the papers, click the STOP button, this
            will end the scanning process. Then click on the EXPORT button and
            the software will save all of the scanned pages into a PDF document
            which will appear on the Right Hand Side of the screen. Double click
            on the document to open it and then you can save it into your
            folders and it will be ready to be uploaded into the SWISH AI
            system.
          </div>
          <img
            src="/help/TT_scan_2_4.png"
            alt="Scanner"
            className="help-section-image"
          />

          <hr className="help-section-divider" />
        </div>
      </div>
    </div>
  );
};

export default Scanner;
